import { render, staticRenderFns } from "./ImportContacts.vue?vue&type=template&id=fd1827ac&scoped=true&"
import script from "./ImportContacts.vue?vue&type=script&lang=js&"
export * from "./ImportContacts.vue?vue&type=script&lang=js&"
import style0 from "./ImportContacts.vue?vue&type=style&index=0&id=fd1827ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1827ac",
  null
  
)

export default component.exports